import React from 'react';
import { Link } from 'react-router-dom';
import { AuthTabs, OtpWhatsAppButton } from '../../components/ui';

// Mobile (APK) Register — single column, full width.
export default function RegisterMobile({ vm }) {
  const {
    form, set, busy, err, alreadyRegistered, forgotPassword, submit,
    step, otp, setOtp, submitOtp, resend, reused, back,
  } = vm;

  // Step 2: the WhatsApp code proves the number is really this person's.
  if (step === 'otp') {
    return (
      <div className="auth-mobile">
        <div className="auth-mobile-brand">Mehfil by Smartify</div>
        <div className="muted auth-mobile-sub">We sent a 4-digit code on WhatsApp to {form.mobile}</div>
        <form onSubmit={submitOtp} className="auth-mobile-form">
          <label className="field">OTP
            <input type="tel" inputMode="numeric" maxLength={4} autoComplete="one-time-code" value={otp} placeholder="4-digit code"
              autoFocus style={{ fontSize: 22, letterSpacing: 6, textAlign: 'center' }}
              onChange={(e) => setOtp(e.target.value)} />
          </label>
          <OtpWhatsAppButton />
          {reused && <div className="muted" style={{ fontSize: 12 }}>Use the code already sent to you (it stays valid for an hour).</div>}
          {err && <div className="auth-mobile-err">{err}</div>}
          <button className="btn primary auth-mobile-btn" disabled={busy}>
            {busy ? 'Verifying…' : 'Verify & Create Account'}
          </button>
        </form>
        <div className="auth-mobile-links">
          <button type="button" className="linklike" onClick={resend} disabled={busy}>Resend code</button>
          <button type="button" className="linklike" onClick={back}>Change details</button>
        </div>
      </div>
    );
  }
  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">Mehfil by Smartify</div>
      <div className="muted auth-mobile-sub" style={{ marginBottom: 0 }}>Create your organiser account</div>
      <AuthTabs active="signup" />
      <form onSubmit={submit} className="auth-mobile-form">
        <label className="field">Name
          <input type="text" autoComplete="given-name" name="given-name" value={form.name} placeholder="First name" onChange={(e) => set('name', e.target.value)} />
        </label>
        <label className="field">Surname
          <input type="text" autoComplete="family-name" name="family-name" value={form.surname} placeholder="Surname (optional)" onChange={(e) => set('surname', e.target.value)} />
        </label>
        <label className="field">Mobile Number
          <input type="tel" inputMode="numeric" autoComplete="tel-national" name="mobile" value={form.mobile} placeholder="10-digit mobile" onChange={(e) => set('mobile', e.target.value)} />
        </label>
        <label className="field">Organiser / Business Name
          <input type="text" autoComplete="organization" name="organization" value={form.organiser} placeholder="e.g. Smart Events Co" onChange={(e) => set('organiser', e.target.value)} />
        </label>
        <label className="field">Password
          <input type="password" autoComplete="new-password" value={form.password} placeholder="Choose a password" onChange={(e) => set('password', e.target.value)} />
        </label>
        <label className="field">Confirm Password
          <input type="password" autoComplete="new-password" value={form.confirm} placeholder="Re-enter password" onChange={(e) => set('confirm', e.target.value)} />
        </label>
        {err && (
          <div className="auth-mobile-err">
            {err}
            {alreadyRegistered && <> <Link to="/">Sign in</Link> or <button type="button" className="linklike" onClick={forgotPassword}>reset the password with OTP</button>.</>}
          </div>
        )}
        <button className="btn primary auth-mobile-btn" disabled={busy}>
          {busy ? 'Sending OTP…' : 'Continue — verify by WhatsApp'}
        </button>
      </form>
      <div className="auth-mobile-links">
        <button type="button" className="linklike" onClick={forgotPassword}>Added by an admin already? Set your password with OTP</button>
      </div>
    </div>
  );
}
